/**
 * @function getCurrentModal:
 * @description Selects the current modal being played.
 * @param state
 */


export const getCurrentModal = (state: any) => state.modal;


export const getCurrentRowDataModal = (namingForm: string) => (state: any) =>
  state.selectedDataTableModal[namingForm] ?? {};


export const selectedOT = (namingForm: string) => (state: any) =>
  state.selectedDataTableModal[namingForm]?.data ?? {};


export const getRoidOTSelectedGV = (state: any) => state.roidOTSelected;
